import styled from 'styled-components';
import StandardTextField from 'Common/Components/StandardTextField/index';
import { Input } from 'Common/Components/StandardTextField/styled';

export const Wrapper = styled.div`
border-radius: 3px;
background-color: ${({ theme }) => theme.backgrounds.detailModalFields};
padding: 14px 20px 26px 20px;
user-select: none;
font-size: 13px;
font-weight: 300;
color: #5E6667;
padding: 0px 20px 20px 20px;
`;

Wrapper.displayName = 'Wrapper';

export const TextField = styled(StandardTextField)`
  ${Input} {
    &:focus{
      background-color: ${({ theme }) => theme.textfield.focus};
    }
  }
`;
TextField.displayName = 'TextField';
